import useCondStore from '../../ConditionsForm/zustand/store'
import helpData from './helpData'

/** Возвращает данные, по которым будет генерироваться справка по выбранному полю */
export function useGetData() {
	const helpSection = useCondStore((store) => store.helpSection)

	return helpData[helpSection]
}
